import { Box, CircularProgress } from "@mui/material";

const CustomSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        height: "90vh",
        alignItems: "center",
      }}
    >
      <CircularProgress size={80} sx={{ color: "#4DCAFA" }} />
    </Box>
  );
};

export default CustomSkeleton;
